"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.elapsedTime = void 0;
var oneDay = 60 * 60 * 24;
var oneHour = 60 * 60;
var oneMinute = 60;
var oneSecond = 1000;
/**
 * Calculate elapsed time between to dates. In days, hours, minutes and seconds
 *
 * @param  {Data}  startDate  Start date
 * @param  {Data}  endDate    End date
 *
 * @return {Object}
 *
 * @tag Data
 * @signature (startDate: Object) => (endDate: Object): Object
 *
 * @example
 * elapsedTime(
 *   new Date("June 1, 2018 00:00:00")
 * )(
 *   new Date("June 1, 2018 03:24:00")
 * )
 * // => { days: 0, hours: 3, minutes: 24, seconds: 0 }
 */

var elapsedTime = function elapsedTime(startDate) {
  return function (endDate) {
    var timePassedInSec = Math.abs(startDate - endDate) / oneSecond; // Number of days

    var days = Math.floor(timePassedInSec / oneDay); // Hours left after removing days

    var hours = Math.floor((timePassedInSec - days * oneDay) / oneHour); // Minutes left after removing days and hours

    var minutes = Math.floor((timePassedInSec - days * oneDay - hours * oneHour) / oneMinute); // Seconds left after removing days, hours and minutes

    var seconds = Math.floor(timePassedInSec - days * oneDay - hours * oneHour - minutes * oneMinute);
    return {
      days: days,
      hours: hours,
      minutes: minutes,
      seconds: seconds
    };
  };
};

exports.elapsedTime = elapsedTime;